






export interface AppStateType {

    isWait: boolean;
    isMultiplier: boolean;
    currentBet: boolean
    autoCahsout: boolean
    isMultiplierGreen: boolean
    isCurveGreen:boolean
    classicCashout:boolean
    cashingOut:boolean

}

const initialState: AppStateType =
{
    isWait: false,
    isMultiplier: false,
    currentBet: false,
    autoCahsout: true,
    isMultiplierGreen: false,
    isCurveGreen:false,
    classicCashout:false,
    cashingOut:false

}

export class AppState {
    private state: AppStateType = initialState;
    constructor() {}

    getState(): AppStateType {
        return this.state;
    }
    setState(newState: Partial<AppStateType>): void {
        const combinedState = { ...this.state, ...newState };
        // Check if the new state is actually different to prevent unnecessary updates
        if (JSON.stringify(this.state) !== JSON.stringify(combinedState)) {
            this.state = combinedState;
        }
    }
}





export const state = new AppState()
//subscriptions 


